import React from "react";
import { useTranslation } from "react-i18next";

import { NavigationConfigId } from "../../../../commons/config/customer-groups";
import * as icons from "../../../../resources/icons";
import CenteredContent from "../../../commons/components/CenteredContent/CenteredContent";
import Headline from "../../../commons/components/Headline/Headline";
import Icon from "../../../commons/components/Icon/Icon";
import MainContentLayout from "../../../commons/components/MainContentLayout/MainContentLayout";
import MainNavigationTile from "../../../commons/components/MainNavigationTile/MainNavigationTile";
import TileGrid from "../../../commons/components/TileGrid/TileGrid";
import AppLogoPartial from "../../../commons/container/App/AppLogoPartial";
import getBikeCenterName from "../../../commons/libs/bike-center-name";
import { useAppHistory } from "../../../commons/libs/hooks/use-app-routing";
import useEnv from "../../../commons/libs/queries/use-env";
import { useSettings } from "../../../commons/libs/queries/use-settings";
import { useWallpaperConfig } from "../../../commons/libs/queries/use-wallpaper-config";
import { ROUTES } from "../../../commons/routes";

const productOverviewIconMap = {
  [NavigationConfigId.Bicycle]: icons.IconLargeBike,
  [NavigationConfigId.Motorcycle]: icons.IconLargeMotorbike
};

const MainNavigationPage = () => {
  const { t } = useTranslation(["mobile"]);
  const history = useAppHistory();

  const env = useEnv();
  const settings = useSettings();
  const wallpaperConfig = useWallpaperConfig();

  const handleLinkClick = (_event: React.MouseEvent<HTMLElement>, href: string) => {
    history.push(href);
  };

  return (
    <MainContentLayout
      layout="full"
      headerRight={<AppLogoPartial />}
      backgroundImage={wallpaperConfig.file}
      hideHeaderBackground={wallpaperConfig.shouldHideMainNavigationHeaderBackground}
    >
      <CenteredContent>
        <TileGrid
          columns={1}
          shadow
          hideShadow={wallpaperConfig.shouldHideTileGridShadow}
          slideIn
          header={
            <Headline noWrap variant={wallpaperConfig.associatedVariant} kind="hero">
              {getBikeCenterName(settings.initialized.customization)}
            </Headline>
          }
        >
          <MainNavigationTile
            href={ROUTES.PRODUCT_FINDER_OVERVIEW.INDEX}
            icon={<Icon source={productOverviewIconMap[env.customerGroupConfig.navigation]} />}
            label={t("mobile:mainNavigationPageNavigation.navigationItems.findBikes")}
            onClick={handleLinkClick}
            transparent={wallpaperConfig.shouldMainNavigationTilesBeTransparent}
          />
        </TileGrid>
      </CenteredContent>
    </MainContentLayout>
  );
};

export default MainNavigationPage;
